export enum ForumTypeEnum {
  FELLOWSHIP = 1,
  PRAYER = 2,
  TESTIMONY = 3,
  BUSINESS = 4,
  DATING = 5,
  ALL = 6
}
